/**
 * API服务层
 * 封装与后端API的通信
 */

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

/**
 * 计算星宿
 */
export async function calculateConstellation(birthday: string, birthHour?: number, userUuid?: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/calculate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        birthday,
        birthHour,
        userUuid
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `请求失败: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('测算API调用失败:', error);
    throw error;
  }
}

/**
 * 获取星宿详情
 */
export async function getConstellationDetail(constellationId: string) {
  try {
    const response = await fetch(`${API_BASE_URL}/constellations/${constellationId}`);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `请求失败: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('获取星宿详情失败:', error);
    throw error;
  }
}

/**
 * 获取所有星宿列表
 */
export async function getAllConstellations() {
  try {
    const response = await fetch(`${API_BASE_URL}/constellations`);

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `请求失败: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('获取星宿列表失败:', error);
    throw error;
  }
}

/**
 * 获取用户测算历史
 */
export async function getCalculationHistory(userUuid: string, limit = 10, offset = 0) {
  try {
    const response = await fetch(
      `${API_BASE_URL}/calculate/history?userUuid=${userUuid}&limit=${limit}&offset=${offset}`
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || `请求失败: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('获取测算历史失败:', error);
    throw error;
  }
}

/**
 * 生成用户UUID
 */
export function generateUserUuid(): string {
  return 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
}

/**
 * 健康检查
 */
export async function healthCheck() {
  try {
    const response = await fetch(`${API_BASE_URL}/health`);
    
    if (!response.ok) {
      throw new Error(`健康检查失败: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('健康检查失败:', error);
    throw error;
  }
}